import { ConversationData } from '@zonofi/zono-money-store';
import React from 'react';
import { ConversationUpdateModal } from '../../conversation-update-modal/conversation-update-modal';
import { ModalContentsList } from '../../modal-contents-list';
import { useUpdateStatus } from '../../hooks/update-status';
import { ModalContentItemData } from '../../../types';

interface UpdateStatusModalProps {
  open: boolean;
  onClose: () => void;
  customerName: string;
  conversationId: string;
  currentStatus: string;
  updateConversations: (item: ConversationData) => void;
}

export const UpdateStatusModal: React.FC<UpdateStatusModalProps> = ({
  open,
  onClose,
  customerName,
  updateConversations,
  conversationId,
  currentStatus,
}) => {
  const { statusData, onUpdateStatus } = useUpdateStatus({
    updateConversations: (item: ConversationData) => {
      updateConversations(item);
      onClose();
    },
  });

  const statuses: ModalContentItemData[] = statusData.map(
    ({ title, image }) => ({
      title,
      icon: <img src={image} alt={title} />,
      onPress: () => {
        onUpdateStatus({ conversationId, status: title });
        onClose();
      },
      isSelected: title === currentStatus,
    })
  );

  return (
    <ConversationUpdateModal
      open={open}
      onClose={onClose}
      header="Change Status"
      customerName={customerName}
    >
      <ModalContentsList data={statuses} showSelection={true} />
    </ConversationUpdateModal>
  );
};
